import Link from "next/link";
import { ERROR_146 } from "@/lib/error-146";

/**
 * Pantalla que sustituye resultados, fichas y categorías alusivas a Halloween
 * o Día de Muertos (ver src/lib/error-146.ts). Con `compact` se usa dentro de
 * paneles pequeños, como el desplegable del buscador o el chat de Rufus.
 */
export function Error146({ compact = false }: { compact?: boolean }) {
  if (compact) {
    return (
      <div className="flex items-center gap-3 p-4 text-left">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src="/brand/rufus.webp" alt="Rufus, la mascota de SuCom" className="w-14 h-auto shrink-0" />
        <div className="min-w-0">
          <p className="text-xs font-black tracking-widest text-primary">ERROR {ERROR_146.code}</p>
          <p className="text-sm font-bold">{ERROR_146.title}</p>
          <p className="text-xs text-muted-foreground">
            {ERROR_146.verse} — {ERROR_146.reference}
          </p>
          <p className="text-xs mt-1">{ERROR_146.message}</p>
          <Link href={ERROR_146.href} className="inline-block mt-2 text-xs font-semibold text-primary hover:underline">
            {ERROR_146.cta} →
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6 py-10">
      <div className="max-w-md text-center">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src="/brand/rufus.webp"
          alt="Rufus, la mascota de SuCom"
          width={144}
          height={240}
          className="mx-auto mb-4 h-60 w-auto"
        />
        <p className="text-5xl font-black text-primary mb-3">ERROR {ERROR_146.code}</p>
        <h1 className="text-2xl font-black mb-3">{ERROR_146.title}</h1>
        <blockquote className="text-lg italic mb-1">{ERROR_146.verse}</blockquote>
        <p className="text-sm font-semibold text-muted-foreground mb-4">— {ERROR_146.reference}</p>
        <p className="text-sm mb-6">{ERROR_146.message}</p>
        <Link
          href={ERROR_146.href}
          className="inline-block px-5 py-2.5 rounded-lg bg-primary text-primary-foreground text-sm font-semibold hover:bg-primary/90"
        >
          {ERROR_146.cta}
        </Link>
      </div>
    </div>
  );
}
